import { useEffect, useRef } from 'react';
import useCiaData from '@components/EntityDrawers/components/CiaInputsGroup/hooks/useCiaData';
import { useAppDispatch } from '@hooks/store';
import { projectsApi } from '@store/services/projects';
import { QueryTags } from '@store/services/tags';

// Node DTOs fetched while Secure-by-Design was off have its data stripped.
const useRefetchNodesOnSbdChange = () => {
  const dispatch = useAppDispatch();
  const { isCiaActivated, isLoading } = useCiaData();
  const previous = useRef<boolean | null>(null);

  useEffect(() => {
    if (isLoading) return;

    if (previous.current !== null && previous.current !== isCiaActivated) {
      dispatch(projectsApi.util.invalidateTags([QueryTags.ProjectNodes]));
    }

    previous.current = isCiaActivated;
  }, [isCiaActivated, isLoading]);
};

export default useRefetchNodesOnSbdChange;
